import { render, staticRenderFns } from "./picture-edit.vue?vue&type=template&id=bf909f18"
import script from "./picture-edit.vue?vue&type=script&lang=js"
export * from "./picture-edit.vue?vue&type=script&lang=js"
import style0 from "./picture-edit.vue?vue&type=style&index=0&id=bf909f18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports